// plugins/plyr.client.ts
import { defineNuxtPlugin } from '#app'
import Plyr from 'plyr'
import 'plyr/dist/plyr.css'

export default defineNuxtPlugin(nuxtApp => {
    // make Plyr globally available as `Plyr`
    // so that in your component `new Plyr(...)` works out of the box
    if (process.client) {
        // attach to window for pure-script callers
        window.Plyr = Plyr
        // also expose via Nuxt injection if you prefer
        nuxtApp.provide('Plyr', Plyr)
    }
})
